/**
 * The two full-screen cards: the loading veil and the title.  boot.js drops
 * the veil when the cats land; context.js drops the title on the first
 * click/key and rewrites its hint line for a device with neither.
 */
import "./overlay.css";
import { mount } from "./dom.js";

export function mountOverlay() {
  const loading = mount(`
<div id="loading"><strong>Waking the cats</strong><span>loading avatars</span></div>`);
  const overlay = mount(`
<div id="overlay"><strong>Cat World</strong><span>click or press W to play</span></div>`);
  return { loading, overlay, overlayHint: overlay.querySelector("span") };
}
